import React from 'react';
import { Paper, Text, Avatar, Badge } from '@mantine/core';
import { Phone } from 'lucide-react';
interface NumberWidgetProps {
  phoneNumber: string;
  name: string;
  isActive: boolean;
  lastConnection: string;
  iconColor?: string;
  onClick?: () => void;
}
export function NumberWidget({
  phoneNumber,
  name,
  isActive,
  lastConnection,
  iconColor = '#0047AB',
  onClick
}: NumberWidgetProps) {
  return <Paper radius="lg" p="md" withBorder className="flex items-center justify-between hover:shadow-md transition-shadow cursor-pointer" onClick={onClick} data-id="element-96">
      <div className="flex items-center" data-id="element-97">
        <Avatar radius="xl" size="md" style={{
        backgroundColor: iconColor,
        color: 'white'
      }} data-id="element-98">
          <Phone size={20} color="white" data-id="element-99" />
        </Avatar>
        <div className="ml-3" data-id="element-100">
          <Text fw={500} data-id="element-101">{name}</Text>
          <Text size="sm" c="dimmed" data-id="element-102">
            {phoneNumber}
          </Text>
        </div>
      </div>
      <div className="flex flex-col items-end" data-id="element-103">
        <Badge color={isActive ? 'green' : 'red'} variant="light" className="mb-1" data-id="element-104">
          {isActive ? 'Ativo' : 'Inativo'}
        </Badge>
        <Text size="xs" c="dimmed" data-id="element-105">
          Última conexão: {lastConnection}
        </Text>
      </div>
    </Paper>;
}